import {Stack, styled} from '@mui/material';

export const StyledAddressContainer = styled(Stack)`
	flex-direction: column;
	justify-content: space-between;
	gap: 8px;
`;

export const StyledContainer = styled(Stack)`
	gap: 8px;
`;
